import angular from 'angular';
import _ from 'lodash';
import moment from 'moment';
import $ from 'jquery';
import Logger from '../../../shared/logger';
import template from './jobsView.html';
import './tableTemplates/recruiterJobsTable.html';
import './tableTemplates/employerJobsTable.html';
import './tableTemplates/jobsSummaryTable.html';
import { DEFAULT_OFFICE } from '../../office-list';
import './style.scss';

export class TalenyaJobComponent {
    loading = false;
    isLoadingPositionsTable = false;
    isLoadingNextPage = false;
    isListLoadingComplete = false;

    tableId = 'talenyaTableToolbar';

    pageOptions = {
        page: 0,
        size: 50,
    };

    sortState = {
        columnName: 'created',
        asc: true,
    };

    positionsToDisplay = [];
    totalPositionsToDisplayCount = 0;

    static _employerCache = {};

    /* @ngInject */
    constructor(
        $filter,
        $localStorage,
        $scope,
        $state,
        $sce,
        $timeout,
        $rootScope,
        $window,
        CommonCodeService,
        EMPLOYER_WORKFLOW_STATUS,
        EnvSettings,
        JobListingLineChart,
        NotificationService,
        PositionService,
        permissions,
        StatsService,
        TimeLineService,
        WorkflowService,
        WebAppRouteService,
    ) {
        const talenyaJobsCtrl = this;
        this.EnvSettings = EnvSettings;
        this.notificationService = NotificationService;
        this.positionService = PositionService;
        this.permissions = permissions;
        this.WebAppRouteService = WebAppRouteService;
        this.workflowService = WorkflowService;
        this.$filter = $filter;
        this.$localStorage = $localStorage;
        this.$state = $state;
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.commonCodeService = CommonCodeService;

        this.startLoading = () => this.loading = true;
        this.stopLoading = () => $timeout(() => this.loading = false);

        this.startPositionsTableLoading = () => this.isLoadingPositionsTable = true;
        this.stopPositionsTableLoading = () => $timeout(() => this.isLoadingPositionsTable = false);

        this.startNextPageLoading = () => this.isLoadingNextPage = true;
        this.stopNextPageLoading = () => $timeout(() => this.isLoadingNextPage = false);

        this.filterState = {
            searchValue: '',
            dateValue: _.get(this.$localStorage, 'filterDatePosted', 'LAST_WEEK'),
            projectStatusValue: 'Active',
            showJobProgressState: false,
            modeValue: _.get(this.$localStorage, 'filterMode', 'TALENT_EXPERT_MODE'),
        };

        talenyaJobsCtrl.init = async () => {
            $scope.EMPLOYER_WORKFLOW_STATUS = EMPLOYER_WORKFLOW_STATUS;
            talenyaJobsCtrl.isTalenyaUser = permissions.isTalenyaUser();
            talenyaJobsCtrl.processAnalysisData = [];


            talenyaJobsCtrl.viewMode = this.filterState.modeValue;
            talenyaJobsCtrl.filterBySearchString = this.filterState.searchValue;
            talenyaJobsCtrl.filterDatePosted = this.filterState.dateValue;
            talenyaJobsCtrl.projectsStatusFilter = this.filterState.projectStatusValue;

            this.startLoading();

            try {
                const [
                    { positions, pageInfo },
                    { finishedTarget: target, options },
                ] = await Promise.all([
                    this.fetchPositions({
                        filters: this.filterState,
                        sort: this.sortState.asc ? 'asc' : 'desc',
                    }),
                    JobListingLineChart.getJobListingLineChart(),
                ]);

                this.positionsToDisplay = positions;
                this.totalPositionsToDisplayCount = _.get(pageInfo, '[0].count', 0);
                this.isListLoadingComplete = this.totalPositionsToDisplayCount === this.positionsToDisplay.length;

                positions.forEach((position) => {
                    position.locationData = this.commonCodeService.getLocationData(position);
                });

                this.initScrollListener();
                this.jobListingLineCart(target, options);
            } catch (err) {
                Logger.error(err);
            } finally {
                this.stopLoading();
            }
        };

        talenyaJobsCtrl.initScrollListener = () => {
            angular.element($window).off('scroll');
            angular.element($window).on('scroll', this.fetchMorePositionsIfNeeded);
        };

        talenyaJobsCtrl.jobListingLineCart = async () => {
            const positionArray = _.map(talenyaJobsCtrl.positionsToDisplay, 'positionId');
            if (positionArray.length === 0) {
                talenyaJobsCtrl.stopLoading();

                return;
            }

            const data = await JobListingLineChart.getJobListingLineChart({
                positionIds: positionArray,
                employerIds: [],
            }, talenyaJobsCtrl.positionsToDisplay);

            talenyaJobsCtrl.finishedTarget = {
                target: data.finishedTarget,
            };
            talenyaJobsCtrl.jobListingLineChartResponseOptions = data.options;
            talenyaJobsCtrl.originalDataSource = angular.copy(talenyaJobsCtrl.jobListingLineChartResponseOptions.dataSource);
            talenyaJobsCtrl.dataEnteredByPositionId = JobListingLineChart.getJobListingData();
            angular.forEach(talenyaJobsCtrl.positionsToDisplay, (position) => {
                talenyaJobsCtrl.createJobListingAreaChart(position);
            });

            talenyaJobsCtrl.stopLoading();
            $timeout(() => {
                talenyaJobsCtrl.loadAndApplySortAndFilter();
            });
        };

        talenyaJobsCtrl.fetchMorePositionsIfNeeded = _.debounce(() => {
            if (talenyaJobsCtrl.isLoadingNextPage || talenyaJobsCtrl.isListLoadingComplete) {
                return;
            }
            const windowHeight = 'innerHeight' in window ? window.innerHeight : document.documentElement.offsetHeight;
            const jobsTable = angular.element('.dashboard-job-lisitng.talenya-jobs') && angular.element('.dashboard-job-lisitng.talenya-jobs')[0];

            if (!jobsTable) {
                return;
            }

            const jobsTableHeight = jobsTable.offsetHeight;
            const windowBottom = windowHeight + window.pageYOffset;
            if (windowBottom >= jobsTableHeight) {
                talenyaJobsCtrl.fetchMore();
            }
        }, 200);

        talenyaJobsCtrl.getProcessAnalysis = function () {
            StatsService.getProcessAnalysis(talenyaJobsCtrl.modalDialogData)
                .then((response) => {
                    talenyaJobsCtrl.processAnalysisData = response.result;
                    return response.result;
                })
                .catch(error => Logger.error(error));
        };

        talenyaJobsCtrl.convertStringToDate = function (strDate) {
            try {
                if (strDate) {
                    return moment(strDate)
                        .format('YYYY-MM-DD');
                }
            } catch (error) {
                Logger.info(error);
            }
        };

        talenyaJobsCtrl.updateLastRow = () => {
            let lastRow = '';
            if (talenyaJobsCtrl.viewMode === 'TALENT_EXPERT_MODE') {
                lastRow = {
                    candidateCount: 0,
                    claimed: 0,
                    engaged: 0,
                    ready: 0,
                    sent: 0,
                    hired: 0,
                    rejected: 0,
                    month: 0,
                    placementFee: 0,
                };

                if (!_.isEmpty(talenyaJobsCtrl.positionsToDisplay)) {
                    for (const onePositionData of talenyaJobsCtrl.positionsToDisplay) {
                        lastRow.candidateCount += onePositionData.candidateCount || 0;
                        lastRow.claimed += onePositionData.jobClaimed;
                        lastRow.engaged += onePositionData.jobEngaged;
                        lastRow.ready += onePositionData.jobReady;
                        lastRow.sent += onePositionData.jobSent;
                        lastRow.hired += onePositionData.jobHired;
                        lastRow.rejected += onePositionData.jobRejected;
                        if (onePositionData) {
                            lastRow.month += $filter('calculateMonthPostedDays')(onePositionData.created, 'dd/MM/yy');
                        }
                    }
                    lastRow.month /= talenyaJobsCtrl.positionsToDisplay.length;
                }
            } else if (talenyaJobsCtrl.viewMode === 'EMPLOYER_MODE') {
                lastRow = {
                    candidateCount: 0,
                    rate: 0,
                    contact: 0,
                    claimed: 0,
                    interviews: 0,
                    hired: 0,
                    rejected: 0,
                    posted: 0,
                };

                if (!_.isEmpty(talenyaJobsCtrl.positionsToDisplay)) {
                    for (const onePositionData of talenyaJobsCtrl.positionsToDisplay) {
                        lastRow.candidateCount += onePositionData.candidateCount || 0;
                        lastRow.rate += onePositionData.jobRate;
                        lastRow.contact += onePositionData.jobContact;
                        lastRow.claimed += onePositionData.jobClaimed;
                        lastRow.interviews += onePositionData.jobInterviews;
                        lastRow.hired += onePositionData.jobHired;
                        lastRow.rejected += onePositionData.jobRejected;
                        if (onePositionData) {
                            lastRow.posted += $filter('calculateMonthPostedDays')(onePositionData.created, 'dd/MM/yy');
                        }
                    }
                    lastRow.posted /= talenyaJobsCtrl.positionsToDisplay.length;
                }
            }
            talenyaJobsCtrl.lastRow = lastRow;
        };

        talenyaJobsCtrl.selectedRowData = [];

        talenyaJobsCtrl.openModalDialog = function (job) {
            talenyaJobsCtrl.resetDataValues();
            talenyaJobsCtrl.selectedRowData.logoURL = job.employerDetails.logoURL;
            talenyaJobsCtrl.selectedRowData.jobTitle = job.jobTitle;
            talenyaJobsCtrl.selectedRowData.postedDate = $filter('calculatePostedDate')(job.created);
            talenyaJobsCtrl.selectedRowData.employerName = job.employerDetails.name;

            StatsService.getProcessAnalysis({
                positionId: job.positionId,
            })
                .then((response) => {
                    talenyaJobsCtrl.processAnalysisData = response.result;

                    // Needed when we want to count all the talent experts in the result
                    for (let i = 0; i < talenyaJobsCtrl.processAnalysisData.length; i++) {
                        angular.forEach(talenyaJobsCtrl.processAnalysisData[i].details, (detailsData) => {
                            talenyaJobsCtrl.totalRowCount[detailsData.status] += detailsData.count;
                        });
                    }
                    talenyaJobsCtrl.modalDialog = true;
                    $('#talenyaJobsViewModalDialog')
                        .modal('show');
                })
                .catch(error => Logger.error(error));
        };

        talenyaJobsCtrl.closeModalDialog = function (state, data) {
            $('#talenyaJobsViewModalDialog')
                .modal('hide');
            $('body')
                .removeClass('modal-open');
            $('.modal-backdrop')
                .remove();

            talenyaJobsCtrl.modalDialog = false;
            talenyaJobsCtrl.goToCandidateData(state, data);
        };

        talenyaJobsCtrl.totalRowCount = {
            Claimed: 0,
            Engaged: 0,
            Ready: 0,
            Sent: 0,
            Hired: 0,
            Rejected: 0,
        };

        talenyaJobsCtrl.resetDataValues = function () {
            talenyaJobsCtrl.totalRowCount.Claimed = 0;
            talenyaJobsCtrl.totalRowCount.Engaged = 0;
            talenyaJobsCtrl.totalRowCount.Ready = 0;
            talenyaJobsCtrl.totalRowCount.Sent = 0;
            talenyaJobsCtrl.totalRowCount.Hired = 0;
            talenyaJobsCtrl.totalRowCount.Rejected = 0;
        };

        TimeLineService.timeline(talenyaJobsCtrl);

        talenyaJobsCtrl.init();
    }

    async fetchPositions(params) {
        params.filters = _.pick(
            params.filters,
            ['dateValue', 'projectStatusValue', 'modeValue', 'searchValue'],
        );

        const activeOffice = this.$localStorage.activeOffice || DEFAULT_OFFICE;

        const { result } = await this.workflowService.postWorkflowCountersPaginated({ ...params, office: activeOffice });
        return result;
    }

    async fetchMore() {
        try {
            if (this.isLoadingNextPage || this.isListLoadingComplete) {
                return;
            }
            this.startNextPageLoading();
            const { positions, pageInfo } = await this.fetchPositions({
                filters: this.filterState,
                pageOptions: {
                    page: this.pageOptions.page + 1,
                    size: this.pageOptions.size,
                },
                sort: this.sortState.asc ? 'asc' : 'desc',
            });

            positions.forEach((position) => {
                position.locationData = this.commonCodeService.getLocationData(position);
            });

            this.positionsToDisplay = [
                ...this.positionsToDisplay,
                ...positions,
            ];
            this.totalPositionsToDisplayCount = _.get(pageInfo, '[0].count', 0);
            this.isListLoadingComplete =
                this.totalPositionsToDisplayCount === this.positionsToDisplay.length
                || _.isEmpty(positions);

            this.pageOptions.page += 1;
            this.$scope.$apply();
        } catch (e) {
            Logger.error(e);
        } finally {
            this.stopNextPageLoading();
        }
    }

    async showDashboardComment(position) {
        try {
            const { result: response } = await this.positionService.getPositionComment(position.positionId);
            this.currentJob = { recruiterId: this.permissions.getRecruiterId(), positionId: position.positionId };
            this.positionComment = response;
            this.dialogComment = this.positionComment;
            this.openDashboardCommentModalDialog(this);
        } catch (err) {
            Logger.error(err);
        }
    }

    async editDashboardComment(form) {
        form.$setSubmitted(true);

        this.positionComment = angular.copy(this.dialogComment);

        try {
            const { recruiterId, positionId } = this.currentJob;
            this.closeDashboardCommentModalDialog();
            this.startLoading();
            await this.positionService.putPositionComment(positionId, {
                recruiterId,
                comment: this.positionComment,
            });
            this.dialogComment = '';
            this.notificationService.success('DASHBOARD_COMMENT_SAVE_SUCCESS');
        } catch (err) {
            Logger.error(err);
            this.notificationService.error('DASHBOARD_COMMENT_SAVE_ERROR');
            this.stopLoading();
        } finally {
            this.stopLoading();
        }
    }

    openDashboardCommentModalDialog(data) {
        this.modalDialogData = data;
        $('#commentsDialog').modal('show');
        this.modalDialog = true;
    }

    closeDashboardCommentModalDialog() {
        window.onbeforeunload = null;
        this.modalDialogData = null;
        this.dialogComment = '';
        $('#commentsDialog')
            .modal('hide');
        this.modalDialog = false;
    }

    loadAndApplySortAndFilter() {
        this.loadFilterState();
        this.loadSortState();
        this.applyFilter(this.filterState);
        this.applySort(this.sortState);
    }

    saveFilterState(filterState) {
        const tableState = this.storage[this.tableId];

        if (tableState) {
            tableState.filterState = filterState;
        } else {
            this.storage[this.tableId] = { filterState };
        }
    }

    async onFilterStateChange(filterState) {
        try {
            const { dateValue, projectStatusValue, modeValue, searchValue = '' } = filterState;

            if (
                this.filterDatePosted !== dateValue
                || this.projectsStatusFilter !== projectStatusValue
                || this.viewMode !== modeValue
                || _.get(this, 'filterBySearchString', '') !== searchValue
            ) {
                this.filterState = filterState;
                this.startPositionsTableLoading();
                await this.fetchFirstPage();
            }

            this.applyFilter(filterState);

            const self = this;
            this.$timeout(() => {
                self.$scope.$apply();
            });
        } catch (e) {
            Logger.error(e);
        } finally {
            this.stopPositionsTableLoading();
        }
    }

    async fetchFirstPage() {
        const { positions, pageInfo } = await this.fetchPositions({
            filters: this.filterState,
            sort: this.sortState.asc ? 'asc' : 'desc',
        });

        positions.forEach((position) => {
            position.locationData = this.commonCodeService.getLocationData(position);
        });

        this.pageOptions.page = 1;

        this.positionsToDisplay = positions;
        this.totalPositionsToDisplayCount = _.get(pageInfo, '[0].count', 0);
        this.isListLoadingComplete = this.totalPositionsToDisplayCount === this.positionsToDisplay.length;
    }

    applyFilter({ searchValue, dateValue, projectStatusValue, showJobProgressState, modeValue }) {
        this.blnShowJobProgression = showJobProgressState;

        this.$localStorage.filterMode = modeValue;
        this.$localStorage.filterDatePosted = dateValue;

        this.filterBySearchString = searchValue;
        this.filterDatePosted = dateValue;
        this.projectsStatusFilter = projectStatusValue;
        this.viewMode = modeValue;
    }

    getTalentExpertColummnValue = (position) => {
        let result = '';
        const recruiters = position.recruiters || position.recruiterDetails;
        const recruiterCount = recruiters.length;

        if (recruiterCount === 1) {
            result = _.get(position, 'recruiterDetails[0].fullName', '') || _.get(position, 'recruiters[0].name', '');
        }

        if (recruiterCount > 1) {
            result = `${recruiterCount} TE`;
        }

        return result;
    };

    getEmployerNameString = (position, full) => {
        const employerName = position?.employerDetails?.name;

        return full ? employerName : `${employerName.substr(0, 60)}${employerName?.length > 60 ? '...' : ''}`;
    };

    goToCandidateData(state, data) {
        if (state === 'employer.candidatesJob') {
            return this.WebAppRouteService.goToEmployerCandidatesPage(data);
        }

        this.$state.go(state, data);
    }

    get storage() {
        return this.$localStorage;
    }

    applySort({ asc }) {
        this.asc = asc;
    }

    onSortStateChange(sortState) {
        this.sortState = sortState;
    }

    async onPostedColumnClick() {
        if (this.isListLoadingComplete) {
            const sortState = this.sortState;
            this.sortState.asc = !this.sortState.asc;
            this.saveSortState(sortState);
            this.onSortStateChange(sortState);
        } else {
            this.sortState.asc = !this.sortState.asc;
            this.startPositionsTableLoading();
            await this.fetchFirstPage();
            this.stopPositionsTableLoading();
        }
    }

    loadFilterState() {
        const tableState = this.storage[this.tableId];

        if (tableState) {
            const { filterState } = this.storage[this.tableId];

            if (filterState) {
                this.onFilterStateChange(filterState);
            }
        }
    }

    loadSortState() {
        const tableState = this.storage[this.tableId];

        if (tableState) {
            const { sortState } = this.storage[this.tableId];

            if (sortState) {
                this.onSortStateChange(sortState);
            }
        }
    }

    openEmployerPosition($event, position) {
        $event.stopPropagation();

        const { positionId } = position;
        const employerId = position.employerDetails._id || position.employerDetails.id || position.employerDetails.employerId;

        this.WebAppRouteService.goToViewJobPage({ employerId, positionId });
    }

    openRecruiterPosition($event, position) {
        $event.stopPropagation();
        const { $state, permissions } = this;
        const positionId = position?._id || position?.positionId;
        const recruiterId = permissions.getRecruiterId();
        const url = $state.href('recruiter.openPosition', { positionId, recruiterId });

        window.open(url, '_blank');
    }

    getRecruitersName(position) {
        const recruiters = position.recruiters || position.recruiterDetails || [];

        return recruiters.map(item => (item.name || item.fullName)).join('\n') || '';
    }

    saveSortState(sortState) {
        const tableState = this.storage[this.tableId];

        if (tableState) {
            tableState.sortState = sortState;
        } else {
            this.storage[this.tableId] = { sortState };
        }
    }

    getPreparedString(text) {
        return (text || '').toString().toLowerCase();
    }

    isTextMatchQuery(text, query) {
        return this.getPreparedString(text).indexOf(this.getPreparedString(query)) >= 0;
    }
}

export const TalenyaJobComponentConfiguration = {
    template,
    controller: TalenyaJobComponent,
    controllerAs: 'talenyaJobsCtrl',
};

angular.module('TALENYA-FE').component('talenyaJobComponent', TalenyaJobComponentConfiguration);
